import { fetchGeolocation } from '../../ducks/global.duck';
import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
import { checkIPForUserCreationAPI } from '../../util/api';
export const TOS_ASSET_NAME = 'terms-of-service';
export const PRIVACY_POLICY_ASSET_NAME = 'privacy-policy';

// ================ Action types ================ //

export const CHECK_IP_REQUEST = 'app/AuthenticationPage/CHECK_IP_REQUEST';
export const CHECK_IP_SUCCESS = 'app/AuthenticationPage/CHECK_IP_SUCCESS';
export const CHECK_IP_FAILURE = 'app/AuthenticationPage/CHECK_IP_FAILURE';

// ================ Reducer ================ //

const initialState = {
  checkIpLoading: false,
  checkIpData: null,
  checkIpError: null,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case CHECK_IP_REQUEST:
      return { ...state, checkIpLoading: true, checkIpError: null };
    case CHECK_IP_SUCCESS:
      return { ...state, checkIpLoading: false, checkIpData: action.payload };
    case CHECK_IP_FAILURE:
      return { ...state, checkIpLoading: false, checkIpError: action.payload };

    default:
      return state;
  }
}

// ================ Action creators ================ //

const checkIpRequest = () => ({ type: CHECK_IP_REQUEST });
const checkIpSuccess = data => ({ type: CHECK_IP_SUCCESS, payload: data });
const checkIpFailure = error => ({ type: CHECK_IP_FAILURE, payload: error });

// ================ Thunks ================ //

export const checkIpForUserCreation = body => async dispatch => {
  dispatch(checkIpRequest());
  try {
    const response = await checkIPForUserCreationAPI(body);
    dispatch(checkIpSuccess(response.data));
    return response;
  } catch (error) {
    dispatch(checkIpFailure(error.message));
    return error;
  }
};

export const loadData = (params, search) => dispatch => {
  const pageAsset = {
    termsOfService: `content/pages/${TOS_ASSET_NAME}.json`,
    privacyPolicy: `content/pages/${PRIVACY_POLICY_ASSET_NAME}.json`,
  };
  dispatch(fetchGeolocation());
  return dispatch(fetchPageAssets(pageAsset, true));
};
